import DayjsExtended from "@logic/DayjsExtended";

export default {
  // Returns a date with the days added to the passed date.
  // NOTE: Does not modify the passed date
  addDays(input: Date, daysToAdd: number) {
    const date = new Date(input);
    date.setDate(date.getDate() + daysToAdd);
    return date;
  },

  daysBetween(startDate: Date, endDate: Date) {
    var msPerDay = 24 * 60 * 60 * 1000;
    var diff = this.getUTC(endDate) - this.getUTC(startDate);
    return diff / msPerDay;
  },

  getUTC(input): any {
    var date = new Date(input);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  },

  formatDateRangeTwoDates(startDateString: string, endDateString: string, includeYear = true): string {
    if (!startDateString || startDateString.length === 0) return "";

    const startDate = new Date(startDateString);
    let result = DayjsExtended(startDate).format("MMM Do");
    if (endDateString !== startDateString) {
      const differentMonth = startDate.getMonth() !== new Date(endDateString).getMonth();
      const endDate = new Date(endDateString);
      const format = (differentMonth ? "MMM " : "") + "Do" + (includeYear ? ", YYYY" : "");
      result += " - " + DayjsExtended(endDate).format(format);
    }
    return result;
  },

  formatDateRange(startDateString: string, daysToAdd = 0, includeYear = true, format = ""): string {
    if (!startDateString || startDateString.length === 0) return "";

    const startDate = new Date(startDateString);
    const _format = format || "MMM Do" + (daysToAdd === 0 && includeYear ? ", YYYY" : "");
    let result = DayjsExtended(startDate).format(_format);
    if (daysToAdd > 0) {
      const endDate = this.addDays(startDate, daysToAdd);
      const differentMonth = startDate.getMonth() !== endDate.getMonth();
      const _format = format || (differentMonth ? "MMM " : "") + "Do" + (includeYear ? ", YYYY" : "");
      result += " - " + DayjsExtended(endDate).format(_format);
    }
    return result;
  },

  forceToNoonUTC(date: Date): Date {
    // Repeated other places DatePicker is used
    // Note: Previously we were using setUTCHours(12) but that was causing the date to be off by a day
    // Have to use Date.UTC or it will adjust hours to local time
    const local = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 11, 11));
    return local;
  },

  /**
   * Converts "2025-W1" to "Dec 30 2024 – Jan 5 2025"
   */
  yearWeekToDateRange(weekString: string, formatting = "MMM D YYYY"): string {
    const [year, weekPart] = weekString.split("-");
    const weekNumber = parseInt(weekPart.substring(1));

    // Monday
    const startOfWeek = DayjsExtended().year(parseInt(year)).isoWeek(weekNumber).startOf("isoWeek");
    // Sunday
    const endOfWeek = startOfWeek.endOf("isoWeek");

    const startFormatted = startOfWeek.format(formatting);
    const endFormatted = endOfWeek.format(formatting);

    return `${startFormatted} — ${endFormatted}`;
  },

  formatTimeAgo(input: string | Date | null | undefined): string {
    if (!input) return "—";
    const diffSec = DayjsExtended().diff(DayjsExtended(input), "second");
    if (diffSec < 45) return "a few seconds ago";
    if (diffSec < 90) return "a minute ago";
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 45) return `${diffMin} minutes ago`;
    if (diffMin < 90) return "an hour ago";
    const diffHour = Math.floor(diffMin / 60);
    if (diffHour < 22) return `${diffHour} hours ago`;
    if (diffHour < 36) return "a day ago";
    const diffDay = Math.floor(diffHour / 24);
    if (diffDay < 25) return `${diffDay} days ago`;
    if (diffDay < 45) return "a month ago";
    const diffMonth = Math.floor(diffDay / 30);
    if (diffMonth < 11) return `${diffMonth} months ago`;
    if (diffMonth < 18) return "a year ago";
    const diffYear = Math.floor(diffMonth / 12);
    return `${diffYear} years ago`;
  },

  shortenMonthNamesInString(stringWithMonthNames: string) {
    const map = {
      january: "Jan",
      february: "Feb",
      march: "Mar",
      april: "Apr",
      may: "May",
      june: "Jun",
      july: "Jul",
      august: "Aug",
      september: "Sep",
      october: "Oct",
      november: "Nov",
      december: "Dec",
    };

    const regex = /\b(January|February|March|April|May|June|July|August|September|October|November|December)\b/gi;

    return stringWithMonthNames.replace(regex, match => map[match.toLowerCase()]);
  },
};
